export const getShouldForwardPropFn = <T extends Record<string, unknown>>(propsToOmit?: (keyof T)[]) => {
  if (!propsToOmit || propsToOmit.length === 0) {
    // If no props to omit, filter out all props that start with $
    return (prop: string) => !prop.startsWith('$');
  }

  const propsToOmitSet = new Set(propsToOmit);

  return (prop: string) => !propsToOmitSet.has(prop);
};
